enum IconSize {
    S = 'small',
    M = 'medium',
    L = 'large',
}

export { IconSize };
